export default "__VITE_ASSET__B3G8BDNx__"